import React, { useContext } from "react";
import PropTypes from "prop-types";

import { LocationContactsTable } from "../../../../components/Locations";

import { ModalContext } from "../../../../components/ModalProvider";

const Contacts = ({ locationRecId }) => {
  const { setModalOpen } = useContext(ModalContext);
  return (
    <LocationContactsTable id={locationRecId} setModalOpen={setModalOpen} />
  );
};
Contacts.propTypes = {
  locationRecId: PropTypes.number.isRequired
};
export default Contacts;
